import { createSlice } from "@reduxjs/toolkit";

export const userRoleSlice = createSlice({
  name: "userRole",
  initialState: {
    role: "",
    info: {},
    permissions: {},
  },
  reducers: {
    setUserRole: (state, action) => {
      state.role = action.payload;
    },
    resetUserRole: (state) => {
      state.role = "";
    },
    setUserInformation: (state, action) => {
      state.info = action.payload;
    },
    resetUserInformation: (state) => {
      state.info = {};
    },
    setUserPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    resetUserPermissions: (state) => {
      state.permissions = {};
    },
    clearAllUser: (state) => {
      state.permissions = {};
      state.info = {};
      state.role = "";
    },
  },
});

export const {
  setUserRole,
  resetUserRole,
  setUserInformation,
  resetUserInformation,
  setUserPermissions,
  resetUserPermissions,
  clearAllUser,
} = userRoleSlice.actions;

export const getUserRole = (state) => state.userRole.role;
export const getUserInformation = (state) => state.userRole.info;
export const getUserPermission = (state) => state.userRole.permissions;

export default userRoleSlice.reducer;
